/**
 * Cria as linhas fixas no topo
 * @param $table
 *  jquery object table
 * @param fixedRowsTop
 *  int numero de linhas fixas no topo
 * @param offsetTop
 *  int distancia da primeira ao topo
 * @private
 */
function _makeRowsTop($table, fixedRowsTop, offsetTop) {
    var $rows = $table.find('tr.is-top');
    var zIndex = 100 + fixedRowsTop;

    if (isNaN(offsetTop)) {
        offsetTop = 0;
    }

    for (var index = 1; index <= fixedRowsTop; index++) {
        var $row = $rows.filter('[data-row="' + index + '"]');
        var $cells = $row.find('th, td');
        var $cellsWithDropdown;

        $cells.addClass('is-top').css('top', offsetTop).css('z-index', zIndex);

        $cellsWithDropdown = $cells.filter('.has-dropdown');

        $cellsWithDropdown.each(function () {
            var zIndexDropdown = 1000 + (zIndex - 100);
            $(this).css('z-index', zIndexDropdown);
            $(this).find('.dropdown-menu').css('z-index', zIndexDropdown + 1);
        });

        // guarda a altura para definir a distancia do topo que a proxima linha deve ter
        offsetTop += $cells.first().outerHeight();

        // diminui o z-index das linhas pois as posteriores sobrescrevem as anteriores
        zIndex--;
    }
}

/**
 * Cria as colunas fixas na esquerda
 * @param $table
 *  jquery object table
 * @param fixedColumnsLeft
 *  int numero de colunas fixas na esquerda
 * @private
 */
function _makeColsLeft($table, fixedColumnsLeft) {
    var colsWidthLeft = {};

    $table.find('tr').each(function () {
        var $cells = $(this).find('th, td');
        var indexLastColumn = $cells.length - 1;
        var cellWidth;
        var $cell;

        // Adiciona as classes para as colunas fixas e guarda a maior largura de cada coluna
        for (let index = 0; index < fixedColumnsLeft; index++) {
            $cell = $cells.eq(index);
            cellWidth = $cell.outerWidth();
            if (colsWidthLeft[index] === undefined) {
                colsWidthLeft[index] = cellWidth;
            } else if (colsWidthLeft[index] < cellWidth) {
                colsWidthLeft[index] = cellWidth;
            }
            $cell.addClass('is-left');

            if ($cell.hasClass('is-top')) {
                $cell.css('z-index', parseInt($cell.css('z-index')) + 1);
            }

            if (index + 1 === fixedColumnsLeft) {
                $cell.addClass('is-last');
            }
        }
    }).each(function () {
        var $cells = $(this).find('th, td');
        var positionLeft = 0;
        var $cell;

        // Posiciona as colunas de acordo com as larguras guardadas
        for (let index = 0; index < fixedColumnsLeft; index++) {
            $cell = $cells.eq(index);
            $cell.css('left', positionLeft + 'px');
            positionLeft += colsWidthLeft[index];
        }
    });
}

/**
 * Cria as colunas fixas na direita
 * @param $table
 *  jquery object table
 * @param fixedColumnsRight
 *  int numero de colunas fixas na direita
 * @private
 */
function _makeColsRight($table, fixedColumnsRight) {
    var colsWidthRight = {};

    $table.find('tr').each(function () {
        var $cells = $(this).find('th, td');
        var indexLastColumn = $cells.length - 1;
        var cellWidth;
        var $cell;

        // Adiciona as classes para as colunas fixas e guarda a maior largura de cada coluna
        for (let index = indexLastColumn; index >= 0 && index > indexLastColumn - fixedColumnsRight; index--) {
            $cell = $cells.eq(index);
            cellWidth = $cell.outerWidth();
            console.log($cell, $cell.outerWidth())
            if (colsWidthRight[index] === undefined) {
                colsWidthRight[index] = cellWidth;
            }
            /*else if (index === indexLastColumn && colsWidthRight[index] < cellWidth) {
                colsWidthRight[index] = cellWidth;
            }*/
            $cell.addClass('is-right');

            if ($cell.hasClass('is-top')) {
                $cell.css('z-index', parseInt($cell.css('z-index')) + 1);
            }

            if (index - 1 === indexLastColumn - fixedColumnsRight) {
                $cell.addClass('is-last');
            }
        }
    }).each(function () {
        var $cells = $(this).find('th, td');
        var indexLastColumn = $cells.length - 1;
        var positionRight = 0;
        var $cell;

        // Posiciona as colunas de acordo com as larguras guardadas
        for (let index = indexLastColumn; index >= 0 && index > indexLastColumn - fixedColumnsRight; index--) {
            $cell = $cells.eq(index);
            $cell.css('right', positionRight + 'px');
            positionRight += colsWidthRight[index];
        }
    });
}

/**
 * Adiciona classes pra corrigir o z-index do dropdown
 * @private
 */
function _initDropdown() {
    $('table.data-table').find('th, td').has('.dropdown').each(function () {
        let $dropdown = $(this).find('.dropdown');

        $(this).addClass('has-dropdown');

        if (!$dropdown.hasClass('has-event-handler')) {
            $dropdown.addClass('has-event-handler');

            $dropdown.on('show.bs.dropdown', function () {
                let $dropdownMenu = $(this).find('.dropdown-menu');
                let $cell = $(this).closest('th, td');
                let zIndexDropdown = parseInt($dropdownMenu.css('z-index')) + 1000;
                let zIndexCell = parseInt($cell.css('z-index')) + 1000;

                $dropdownMenu.css('z-index', zIndexDropdown);
                $cell.addClass('has-dropdown-open').css('z-index', zIndexCell);
            }).on('hidden.bs.dropdown', function () {
                let $dropdownMenu = $(this).find('.dropdown-menu');
                let $cell = $(this).closest('th, td');
                let zIndexDropdown = parseInt($dropdownMenu.css('z-index')) - 1000;
                let zIndexCell = parseInt($cell.css('z-index')) - 1000;

                $dropdownMenu.css('z-index', zIndexDropdown);
                $cell.removeClass('has-dropdown-open').css('z-index', zIndexCell);
            });
        }
    });
}

/**
 * Define a altura da tabela como a area visivel depois do menu fixo do topo
 * @private
 */
function _initAutoResize() {
    var setHeight = function () {
        var height = $(window).height() - ($('.js-menu-fixed-topo:visible').outerHeight() + 25);
        $('table.data-table[data-height="auto"]').each(function () {
            let $table = $(this);
            let $tableContainer = $table.closest('.data-table-container');
            let offset = parseInt($table.data('height-offset'), 10);
            if (isNaN(offset)) {
                offset = 0;
            }
            $tableContainer.css('height', height - offset);

            if ($tableContainer.get(0).scrollWidth > $tableContainer.innerWidth()) {
                $tableContainer.find('.is-left.is-last').addClass('has-shadow');
            } else {
                $tableContainer.find('.is-left.is-last').removeClass('has-shadow');
            }
        });
    };

    setHeight();

    $(window).resize(setHeight);
}

/**
 * Adiciona sombras nas colunas se tiver barra de rolagem horizontal
 * @private
 */
function _initShadows() {
    var setShadows = function () {
        $('.data-table-container').each(function () {
            $(this).find('.is-left.is-last, .is-right.is-last').toggleClass('has-shadow', $(this).innerWidth() < $(this).get(0).scrollWidth);
        });
    };

    setShadows();

    $(window).resize(setShadows);
}

function init() {
    $('table.data-table').each(function () {
        var $table = $(this);
        var $tableContainer = $('<div>', {class: 'data-table-container'});

        var fixedColumnsLeft = parseInt($table.data('cols-left'), 10);
        var fixedColumnsRight = parseInt($table.data('cols-right'), 10);
        var fixedRowsTop = parseInt($table.data('rows-top'), 10);
        var height = parseInt($table.data('height'), 10);
        var offsetTop = parseInt($table.data('offset-top'), 10);

        _initDropdown();

        /*
         * Cria as linhas fixas no topo
         */
        if (fixedRowsTop > 0) {
            _makeRowsTop($table, fixedRowsTop, offsetTop);
        }

        /*
         * Adiciona as classes para as colunas fixas na esquerda e na direita
         * Guarda a maior largura de cada coluna
         * Posiciona as colunas de acordo com as larguras guardadas
         */
        if (fixedColumnsLeft > 0) {
            _makeColsLeft($table, fixedColumnsLeft);
        }
        if (fixedColumnsRight > 0) {
            _makeColsRight($table, fixedColumnsRight);
        }

        if ($table.data('height') === 'auto') {
            $table.wrap($tableContainer);
            _initAutoResize();
        } else {
            $tableContainer.css('height', height);
            $table.wrap($tableContainer);
        }

        _initShadows();
    });
}

function update() {
    $('.data-table-container table.data-table').each(function () {
        var $table = $(this);

        var fixedColumnsLeft = parseInt($table.data('cols-left'), 10);
        var fixedColumnsRight = parseInt($table.data('cols-right'), 10);
        var fixedRowsTop = parseInt($table.data('rows-top'), 10);
        var height = parseInt($table.data('height'), 10);
        var offsetTop = parseInt($table.data('offset-top'), 10);

        _initDropdown();

        /*
         * Cria as linhas fixas no topo
         */
        if (fixedRowsTop > 0) {
            _makeRowsTop($table, fixedRowsTop, offsetTop);
        }

        /*
         * Adiciona as classes para as colunas fixas na esquerda e na direita
         * Guarda a maior largura de cada coluna
         * Posiciona as colunas de acordo com as larguras guardadas
         */
        if (fixedColumnsLeft > 0) {
            _makeColsLeft($table, fixedColumnsLeft);
        }
        if (fixedColumnsRight > 0) {
            _makeColsRight($table, fixedColumnsRight);
        }

        if ($table.data('height') === 'auto') {
            _initAutoResize();
        }

        _initShadows();
    });
}

module.exports = {
    init, update
};


// WEBPACK FOOTER //
// ./resources/assets/layout-novo/js/modulo/dataTable.js